import showdown from "react-showdown";

export const converter = new showdown.Converter();
